// Date 2020-10-10 11:23:47

import sithMesMstLocation from "@/store/sithMes/mst/SithMesMstLocationStore.js";
import sithMesMstLocationShiftRule from "@/store/sithMes/mst/SithMesMstLocationShiftRuleStore.js";
import sithMesMstShift from "@/store/sithMes/mst/SithMesMstShiftStore.js";
import sithMesMstShiftRule from "@/store/sithMes/mst/SithMesMstShiftRuleStore.js";
import sithMesMstShiftTeam from "@/store/sithMes/mst/SithMesMstShiftTeamStore.js";
import sithMesMstShiftTime from "@/store/sithMes/mst/SithMesMstShiftTimeStore.js";
import sithMesMstCalendar from "@/store/sithMes/mst/SithMesMstCalendarStore.js";
import sithMesMstShiftTeamUser from "@/store/sithMes/mst/SithMesMstShiftTeamUserStore.js";
import sithMesMstPosition from "@/store/sithMes/mst/SithMesMstPositionStore.js";
import sithMesMstUserLocation from "@/store/sithMes/mst/SithMesMstUserLocationStore.js";
import sithMesMstUserPosition from "@/store/sithMes/mst/SithMesMstUserPositionStore.js";
import sithMesMstBottleneck from "@/store/sithMes/mst/SithMesMstBottleneckStore.js";
import sithMesMstWorkshop from "@/store/sithMes/mst/SithMesMstWorkshopStore.js";
import sithMesMstWorkshopLocation from "@/store/sithMes/mst/SithMesMstWorkshopLocationStore.js";
import sithMesMstBom from "@/store/sithMes/mst/SithMesMstBomStore.js";
import sithMesReportTemplateRole from "@/store/sithMes/mst/SithMesReportTemplateRoleStore.js";
import sithMesReportTemplate from "@/store/sithMes/mst/SithMesReportTemplateStore.js";
import sithMesMstMachineType from "@/store/sithMes/mst/SithMesMstMachineTypeStore.js";
import sithMesMstProjectPlanTemplate from "@/store/sithMes/mst/SithMesMstProjectPlanTemplateStore.js";
import sithMesMstMilestone from "@/store/sithMes/mst/SithMesMstMilestoneStore.js";
import sithMesMstKam from "@/store/sithMes/mst/SithMesMstKamStore.js";
import sithMesMstLocalStorage from "@/store/sithMes/mst/SithMesMstLocalStorageStore.js";
import sithMesMstMaterial from "@/store/sithMes/mst/SithMesMstMaterialStore.js";
import sithMesMstBasicOperation from "@/store/sithMes/mst/SithMesMstBasicOperationStore.js";
import sithMesMstBasicHeader from "@/store/sithMes/mst/SithMesMstBasicHeaderStore.js";
import sithMesMstKamList from "@/store/sithMes/mst/SithMesMstKamListStore.js";
import sithMesMstLocationTagLoct from "@/store/sithMes/mst/SithMesMstLocationTagLoctStore.js";
import sithMesMstMaterialDocument from "@/store/sithMes/mst/SithMesMstMaterialDocumentStore.js";
import sithMesMstMaterialDrawing from "@/store/sithMes/mst/SithMesMstMaterialDrawingStore.js";
import sithMesMstMaterialDrawingManagement from "@/store/sithMes/mst/SithMesMstMaterialDrawingManagementStore.js";


const genericEntities = [
    'sithMesMstLocation',
    'sithMesMstLocationShiftRule',
    'sithMesMstShift',
    'sithMesMstShiftRule',
    'sithMesMstShiftTeam',
    'sithMesMstShiftTime',
    'sithMesMstCalendar',
    'sithMesMstShiftTeamUser',
    'sithMesMstPosition',
    'sithMesMstUserLocation',
    'sithMesMstUserPosition',
    'sithMesMstBottleneck',
    'sithMesMstWorkshop',
    'sithMesMstWorkshopLocation',
    'sithMesMstBom',
    'sithMesReportTemplateRole',
    'sithMesReportTemplate',
    'sithMesMstMachineType',
    'sithMesMstProjectPlanTemplate',
    'sithMesMstMilestone',
    'sithMesMstKam',
    'sithMesMstLocalStorage',
    'sithMesMstMaterial',
    'sithMesMstBasicOperation',
    'sithMesMstBasicHeader',
    'sithMesMstKamList',
    'sithMesMstLocationTagLoct',
    'sithMesMstMaterialDocument',
    'sithMesMstMaterialDrawing',
    'sithMesMstMaterialDrawingManagement'
]

const entities = {
    sithMesMstLocation,
    sithMesMstLocationShiftRule,
    sithMesMstShift,
    sithMesMstShiftRule,
    sithMesMstShiftTeam,
    sithMesMstShiftTime,
    sithMesMstCalendar,
    sithMesMstShiftTeamUser,
    sithMesMstPosition,
    sithMesMstUserLocation,
    sithMesMstUserPosition,
    sithMesMstBottleneck,
    sithMesMstWorkshop,
    sithMesMstWorkshopLocation,
    sithMesMstBom,
    sithMesReportTemplateRole,
    sithMesReportTemplate,
    sithMesMstMachineType,
    sithMesMstProjectPlanTemplate,
    sithMesMstMilestone,
    sithMesMstKam,
    sithMesMstLocalStorage,
    sithMesMstMaterial,
    sithMesMstBasicOperation,
    sithMesMstBasicHeader,
    sithMesMstKamList,
    sithMesMstLocationTagLoct,
    sithMesMstMaterialDocument,
    sithMesMstMaterialDrawing,
    sithMesMstMaterialDrawingManagement
}

export {genericEntities}

export default entities